import React, { useEffect, useState } from "react";
import "../screens/Dashboard.css";
import SharePopup from "../screens/share_popup";
import QRCode from "qrcode";   // ✅ sahi - npm "qrcode" package (capital R, no icon import)
import ShareWidget from "../screens/share_qr";

const getDataParamFromQrUrl = (qrUrl = "") => {
    try {
        const urlObj = new URL(qrUrl);
        return decodeURIComponent(urlObj.searchParams.get("data") || "");
    } catch (err) {
        return "";
    }
};

const ReferPartnerModal = ({ isOpen, onClose, link, qrCodeUrl }) => {
    const [copied, setCopied] = useState(false);
    const [showShareCreative, setShowShareCreative] = useState(false);
    const [qrDataUrl, setQrDataUrl] = useState(""); // client-side generated QR (data:image/png;base64,...)
    const [qrUrl, setUrl] = useState("");
    console.log("check the url qr code $", link);

    const qrImageUrl = link; // original qrserver image - sirf display fallback ke liye

    const referralLink = getDataParamFromQrUrl(link) || link || "";
    console.log("check the url qr code $", referralLink);

    // ✅ Referral link text se QR khud generate karo (CORS-safe, instant, no network call)
    useEffect(() => {
        setUrl(qrCodeUrl);
        if (referralLink) {
            QRCode.toDataURL(referralLink, { width: 320, margin: 1 })
                .then((dataUrl) => setQrDataUrl(dataUrl))
                .catch((err) => {
                    console.error("QR generate failed:", err);
                    setQrDataUrl("");
                });
        } else {
            setQrDataUrl("");
        }
    }, [referralLink]);

    // Agar dono band hain toh kuch bhi render mat karo
    if (!isOpen && !showShareCreative) return null;

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(referralLink);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error("Copy failed:", err);
        }
    };

    // ✅ Ab client-side generated data URL se download hota hai - koi CORS/network issue nahi
    const handleDownloadQR = (e) => {
        e.preventDefault();
        if (!qrDataUrl) return;
        const a = document.createElement("a");
        a.href = qrDataUrl;
        a.download = "referral-qr-code.png";
        document.body.appendChild(a);
        a.click();
        a.remove();
    };

    // ✅ Ab ye pehle wale Refer a Partner popup ko close karega
    // aur SharePopup ko open karega
    const handleShareQR = () => {
        onClose(); // pehla popup close
        setShowShareCreative(true); // naya SharePopup open
    };

    return (
        <>
            {isOpen && (
                <div className="refer-partner-overlay" onClick={onClose}>
                    <div
                        className="refer-partner-wrapper"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button className="close-btn" onClick={onClose}>
                            &times;
                        </button>

                        <div className="icon">
                            <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                                <circle cx="18" cy="5" r="3" stroke="#6C63FF" strokeWidth="1.5" />
                                <circle cx="6" cy="12" r="3" stroke="#6C63FF" strokeWidth="1.5" />
                                <circle cx="18" cy="19" r="3" stroke="#6C63FF" strokeWidth="1.5" />
                                <path
                                    d="M8.6 10.5L15.4 6.5M8.6 13.5L15.4 17.5"
                                    stroke="#6C63FF"
                                    strokeWidth="1.5"
                                />
                            </svg>
                        </div>

                        <h3>Refer a Partner</h3>
                        <p>
                            Share your partner referral link to invite them to become a Bigul
                            Partner and expand the network together.
                        </p>

                        <div className="scaner-box">
                            <p>
                                Scan this QR code to open your Bigul referral link and register
                                instantly.
                            </p>
                            <div className="qr">
                                {/* client-side generated QR ko priority do; jab tak generate ho raha
                                    ho tab tak purani server image dikha do */}
                                <img src={qrDataUrl || qrImageUrl} alt="Referral QR" />
                            </div>
                            <a href="#" onClick={handleDownloadQR}>
                                ↓ Download QR
                            </a>
                        </div>

                        <p className="or">Or</p>

                        <div className="inp-group">
                            <label>Referral Link</label>
                            <div className="form-group">
                                <input type="text" className="link-imp" value={referralLink} readOnly />
                            </div>
                        </div>

                        <div className="btn-box">
                            <button className="copy-btn" onClick={handleCopy}>
                                {copied ? "Copied!" : "Copy link"}
                            </button>
                            <button className="share-btn" onClick={handleShareQR}>
                                Share QR
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <SharePopup
                isOpen={showShareCreative}
                onClose={() => setShowShareCreative(false)}
                shareUrl={referralLink}
                qrImageDataUrl={qrUrl}
                message="Join Bigul as a Partner"
                title="Share Partner Referral"
                subtitle="Share this partner referral link with your network to grow together."
                page="QR"
            />
            {/* <ShareWidget
                open={showShareCreative}
                onClose={() => setShowShareCreative(false)}
                url="https://bigul.co"
                message="Share Partner Referral"
                image="https://bcms.bigul.co/public/assets/img/mm/15062024121007Basket-Order-1%20(1).png"
            /> */}
        </>
    );
};

export default ReferPartnerModal;
